export async function mirrorPersistentValue(key: string, value: string): Promise<void> {
  if (import.meta.env.VITE_CHANNEL !== "apps_in_toss") return;
  const adapter = await import("../../ait/src/platform");
  await adapter.mirrorPersistentValue(key, value);
}

export async function removePersistentValue(key: string): Promise<void> {
  if (import.meta.env.VITE_CHANNEL !== "apps_in_toss") return;
  const adapter = await import("../../ait/src/platform");
  await adapter.removePersistentValue(key);
}

export function caseShareUrl(caseId: string): string {
  const path = `/case/${encodeURIComponent(caseId)}`;
  return import.meta.env.VITE_CHANNEL === "apps_in_toss" ? `intoss://arabom${path}` : `${location.origin}${path}`;
}

export async function shareCaseLink(caseId: string): Promise<"shared" | "copied"> {
  window.dispatchEvent(new Event("arabom:share-clicked"));
  if (import.meta.env.VITE_CHANNEL === "apps_in_toss") {
    const adapter = await import("../../ait/src/platform");
    return await adapter.shareCase(caseId);
  }
  return shareLink(caseShareUrl(caseId), "경찰청 공개 실종정보를 확인해요.");
}

export function shareActionLabel(): string {
  return "공유하기";
}

export async function copyText(text: string): Promise<void> {
  if(import.meta.env.VITE_CHANNEL==="apps_in_toss"){const adapter=await import("../../ait/src/platform");return adapter.copyText(text);}
  await navigator.clipboard.writeText(text);
}
export async function shareLink(url: string, text: string): Promise<"shared" | "copied"> {
  if (navigator.share) {
    try { await navigator.share({url,text}); return "shared"; }
    catch(error) { if(error instanceof Error && error.name === "AbortError") throw error; }
  }
  await copyText(url);return "copied";
}
